import { useEffect } from 'react'
import { useLoggingOutWarning, useConfirmedLogout, useEditMode } from '../../../store/redux/hooks'
import UserService from '../../../store/services/UserService'
import { environment } from '../../../enviroments/enviroment'
import { setEditMode } from '../../../store/redux/reducers/LoggingOutWarningSlice'

export const useSidebarLogout = () => {
  const { setIsLoggingOutWarning } = useLoggingOutWarning()
  const { isConfirmedLogout } = useConfirmedLogout()
  const { isEditMode } = useEditMode()

  const logout = () => {
    if (isEditMode) {
      setIsLoggingOutWarning(true)
    } else {
      setEditMode(false)
      UserService.logout({ redirectUri: environment.loginUrl }).then()
    }
  }

  useEffect(() => {
    if (isConfirmedLogout) {
      setEditMode(false)
      UserService.logout({ redirectUri: environment.loginUrl }).then()
    }
  }, [isConfirmedLogout])

  return { logout }
}
